import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, className = '', ...props }) => {
  let IconComponent;
  try {
    // If an icon component is passed directly, use it
    // Otherwise, try to find the icon by name in Feather icons (Fi)
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    IconComponent = null;
  }

  if (!IconComponent) {
    return <FiAlertTriangle className={className} {...props} />;
  }

  return React.createElement(IconComponent, { className, ...props });
};

export default SafeIcon;